import { render, staticRenderFns } from "./instantOrder.vue?vue&type=template&id=47f5467e&scoped=true"
import script from "./instantOrder.vue?vue&type=script&lang=js"
export * from "./instantOrder.vue?vue&type=script&lang=js"
import style0 from "./instantOrder.vue?vue&type=style&index=0&id=47f5467e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f5467e",
  null
  
)

export default component.exports